module.exports = __webpack_public_path__ + "static/media/facebook.729cde84.svg";